import { FC, useEffect, useMemo, useState } from "react";
import Popover from "antd/lib/popover";
import { useHistory } from "react-router-dom";
import { getInitials, getUserData, logout, saveUserData } from "../../../utilities/utilities";
import { RouteConstants } from "../../../router/Constants";
import Button from "antd/lib/button";
import Divider from "antd/lib/divider";
import Avatar from "antd/lib/avatar";
import { UserAddOutlined } from "@ant-design/icons";
import Logo from "../../../Images/allure-logo.png";
import { UpCircleOutlined } from "@ant-design/icons";
import HeaderMenuComponent from "./HeaderMenu.component";

import { connect } from "react-redux";
import { RestartTour } from "../../../redux/Tour/Tour.action";
import { BUILD, BuildType } from "../../../constants/Constants";
import LogComponent from "../../../components/Log/Log.component";
import SettingsComponent from "../../../components/Settings/Settings.component";
import WelcomeModal from "../../../constants/WelcomeModal";
import { BASE_URI, API_BASE_URI } from "../../../redux/ApiCall";
import { ApiCallState } from "../../../redux/Utils";
import { Document } from "../../../redux/Document/Document.type";
import { fetchOneDocument } from "../../../redux/Document/Document.action";
import { fetchOneUser } from "../../../redux/User/User.action";
import { User } from "../../../redux/User/User.type";

const HeaderComponent: FC<{
  onCollapse: Function;
  restart: Function;
  fetchDocument: Function;
  fetchUser?: Function;
  document: ApiCallState<Document>;
  user?: ApiCallState<User>;
}> = ({ onCollapse, restart, document, fetchDocument, user, fetchUser }) => {
  const history = useHistory();

  const [data, setData] = useState(getUserData());
  const [tour_visibility, setTourVisibility] = useState(false);

  useEffect(() => {
    const current = getUserData();
    if (current.document_id) {
      fetchDocument(current.document_id);
    } else if (current.id && fetchUser) {
      fetchUser(current.id);
    }
  }, [fetchDocument, fetchUser]);

  useEffect(() => {
    if (user?.payload) {
      setData((prev: any) => ({ ...prev, ...user.payload }));
      const current = getUserData();
      saveUserData({ ...current, ...user.payload });

      if (user.payload.document_id) {
        fetchDocument(user.payload.document_id);
      }
    }
  }, [user?.payload, fetchDocument]);

  const avatarUrl = useMemo(() => {
    const rawUrl = document?.payload?.url;
    if (!rawUrl) return undefined;
    const clean = rawUrl.replace(/\\/g, "/");
    if (clean.startsWith("http://") || clean.startsWith("https://")) return clean;
    const relative = clean.replace(/^\//, "");
    if (relative.startsWith("uploads/")) {
      return `${API_BASE_URI}/${relative}`;
    }
    return `${BASE_URI}/${relative}`;
  }, [document?.payload?.url]);

  return (
    <div className="limit-container">
      <WelcomeModal setTourVisibility={setTourVisibility} />
      <div className="row">
        <div className="header-wrapper">
          <div className="header-breadcrumb">
            <img src={Logo} alt="Logo" style={{width: 160}} />
          </div>
          <HeaderMenuComponent />
          <div className="header-icons">
            {data.is_super_user ? (
              <Button
                className="pt-2"
                type="link"
                icon={<UserAddOutlined />}
                onClick={(e: any) =>
                  history.push(RouteConstants.USER_MANAGEMENT)
                }
              />
            ) : null}
            <LogComponent />
            <Popover
              overlayClassName="header-popover"
              placement="bottomRight"
              content={
                <>
                  <h6 className="con-user">{data ? data.full_name : null}</h6>
                  <h6
                    style={{
                      backgroundColor: "#6a7a9c",
                      display: "inline",
                      color: "white",

                      padding: "6px",
                      borderRadius: "8px",
                      fontSize: "10px",
                    }}
                  >
                    {BUILD === BuildType.ENTERPRISE_PROJECT
                      ? BuildType.PROJECT
                      : BUILD}
                  </h6>
                  {BUILD === BuildType.PROJECT ||
                  BUILD === BuildType.ENTERPRISE_PROJECT ? (
                    <a target="blank" href="https://condigitaleth.com/demo/">
                      <Button
                        className="d-block"
                        type="link"
                        size="middle"
                        icon={
                          <UpCircleOutlined
                            style={{ verticalAlign: "text-bottom" }}
                          />
                        }
                        style={{ paddingLeft: "0px" }}
                      >
                        Upgrade Package
                      </Button>
                    </a>
                  ) : null}

                  <SettingsComponent />

                  {/* <br></br> */}
                  <Divider style={{ marginBottom: "13px" }} />
                  <Button
                    style={{
                      paddingLeft: "0px",
                      marginTop: "0px",
                      paddingTop: "0px",
                    }}
                    className="btn btn-link"
                    onClick={() => {
                      logout();
                      history.push(RouteConstants.LOGIN);
                    }}
                  >
                    Sign Out
                  </Button>
                </>
              }
              trigger="hover"
            >
              <Avatar
                style={{ color: "#fff", backgroundColor: "#FC9A00" }}
                src={avatarUrl}
              >
                {!avatarUrl && getInitials(data.full_name)}
              </Avatar>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Map State to Props
 *
 * @param state
 */
const mapStateToProps = (state: any) => ({
  document: state.document.fetchOne,
  user: state.user.fetchOne,
});

/**
 * Map Dispatch to Props
 *
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: any) => ({
  restart: (action: any) => dispatch(RestartTour(action)),
  fetchDocument: (action: any) => dispatch(fetchOneDocument(action)),
  fetchUser: (action: any) => dispatch(fetchOneUser(action)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);
